import {
  useQuery,
  experimental_streamedQuery as streamedQuery,
} from '@tanstack/react-query'
import { shiftAnalysisKeyWithParams } from 'queries/shifts/keys'
import { getShiftAnalysis } from 'api/shifts/getShiftAnalysis'

export const useShiftAnalysisQuery = (
  request: Parameters<typeof getShiftAnalysis>[0]
) => {
  const { shiftId } = request

  return useQuery({
    queryKey: shiftAnalysisKeyWithParams(shiftId),
    queryFn: streamedQuery({
      queryFn: () => getShiftAnalysis(request),
      refetchMode: 'reset', // keep pushing new chunks onto data[]
    }),
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
